import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_bedding_all: FaireCategoryEntity = {
  token: "cat_bedding-all",
  type: "category",
  name: "All bedding",
  level: 3,
  parentToken: "cat_home-decor-bedding",
  href: "/category/home-decor/bedding",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
